<template>
  <div class="flex column" style="width: 100vm" v-title data-title="关于课程">
    <div v-for="(data, index) in list" :key="index">
      <div class="flex column" style="height: 49px; margin: 0 16px" @click="$router.push({name:'QuestionDetail', params: {question: JSON.stringify(data)}})">
        <div class="flex main-space-between cross-center" style="height: 49px;">
          <span>{{index + 1}}.{{data.title}}</span>
          <img src="../assets/arrow_right.png" style="width: 7px; height: 13px">
        </div>
        <div style="background: #EEEEEEFF; height: 1px; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AboutCourse",
    data () {
      return{
        list: [
          {
            title: '课程是什么？',
            detailTexts: [{title: '课程是根据闯关图书延伸的内容，课程主要目的是教会孩子如何爱上读书以及怎么读书。课程以视频的形式展示，由知名教师主讲。'}]
          },
          {
            title: '如何兑换课程？',
            detailTexts: [{title: '兑换课程需要消耗一定数量的阅芽。'},
              {title: '在阅伴教师端App，点击“教师服务”进入教师服务中心，点击“兑换课程”，可以进入课程列表页。选择自己想要的课程，点击兑换即可。'}]
          },
          {
            title: '如何获取课件？',
            detailTexts: [{title: '课件可提供老师免费查阅，如果要获取课件需要消耗一定数量的阅芽，阅芽兑换成功后，课件会通过邮件的形式发送到老师提供的指定邮箱中。'},
              {title: '获取课件步骤：在阅伴教师端App，点击“教师服务”进入教师服务中心，点击“获取课件”，可以进入课件列表页。选择自己想要的课件点击兑换，输入自己的常用邮箱即可。'}]
          }
        ]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AboutCourse.vue